<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7ZBh4d/image/front.jpg?1739892534572" alt="This image is the cover for the book The Mishaps of Johnny Seagull"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Mishaps of Johnny Seagull
      </h1>
      <p class="bookDescription body article font2">
        <p>Down at the beach, Johnny Seagull’s family are gathering ready to go fishing for lunch and Katie and her Grandpa are hunting for crabs in the rock pools. Cecil Crow is heading their way from the next bay. Johnny is a young seagull, bored with having to eat fish at every mealtime and longing to sample the delights of foods like pepperoni pizza, fries, and ice cream. His best friend Cecil is a mischievous scallywag, always up to no good and forever encouraging Johnny to join him in his schemes. Thoughtful and kind, Katie would hate to see Johnny go hungry. Will Johnny allow himself to be led astray by Cecil Crow and even go so far as to steal to get to try his dream foods, or could it be that tricking Katie enables Johnny to get to try the foods he so desires?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kathryn Turner
      </h2>
      
      <p class="authorDescription body article">Coming from a farming background, Kathryn Turner has a passion for all that are hairy with four legs. Muddy wellingtons, baler twine and ‘eau de wet horse parfum’ are daily occurrences in the life of Kathryn, who would not have it any other way!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?35c69d89